export default class ScrollTo {
    /**
     * Scroll to the y-coordinate defined by input with an animation lasting duration
     *
     * @param {number|Element|string} input The element/y-coordinate to scroll to
     * @param {number} duration Animation duration in milliseconds
     * @param {number} [offset] Allows to adjust the concrete coordinate to scroll to
     */
    static scrollToAnimated(input, duration, offset) {
        if (isNaN(duration)) {
            throw new TypeError('Invalid duration')
        }

        if (typeof offset === 'undefined') {
            offset = 0;
        }

        if (typeof input === 'string') {
            ScrollTo.scrollToAnimated(document.querySelector(input), duration, offset);

            return;
        }
        if (typeof input === 'object') {
            if (typeof input.getBoundingClientRect === 'undefined') {
                throw new TypeError('Input element must implement the method getBoundingClientRect')
            }
            ScrollTo.scrollToAnimated(ScrollTo.getElementOffsetTop(input), duration, offset);

            return;
        }

        if (isNaN(input)) {
            throw new TypeError('Unexpected input')
        }

        const elementY = input + offset;

        const startingY = window.pageYOffset;
        const diff = elementY - startingY;
        let start;

        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        const tick = function (timestamp) {
            if (!start) start = timestamp;
            // Elapsed milliseconds since start of scrolling.
            const time = timestamp - start;
            // Get percent of completion in range [0, 1].
            const percent = Math.min(time / duration, 1);

            window.scrollTo(0, startingY + diff * percent);

            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(tick)
            }
        };
        window.requestAnimationFrame(tick)
    }


    /**
     * @param {HTMLElement} element
     * @return {number}
     */
    static getElementOffsetTop(element) {
        const rect = element.getBoundingClientRect();
        const documentElement = document.documentElement;

        return rect.top + window.pageYOffset - documentElement.clientTop;
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/ScrollTo.js